import PropTypes from 'prop-types';

/**
 * FloatingViewPanel - Schwebender Panel-Rahmen für Tablet/Mobile (#633)
 *
 * Auf Geräten ohne rechte Seitenleiste (Tablet 768–1024 px, Mobile read-only)
 * bleiben die View-Panels wie bisher schwebend über dem Button-Paar
 * (ViewPanelButtons, bottom-4 + 44 px hoch). Desktop dockt die Inhalte
 * stattdessen in die Seitenleiste (PropertiesPanel-Slot).
 */

const FloatingViewPanel = ({ children }) => (
  // w-80: lässt den 6×2-Blühkalender-Zellen ≥ 44 px Breite (Touch-Target)
  <div className="fixed bottom-[72px] left-1/2 z-10 w-80 -translate-x-1/2 rounded-lg border border-gray-200 bg-white p-3 shadow-lg">
    {children}
  </div>
);

FloatingViewPanel.propTypes = {
  children: PropTypes.node.isRequired,
};

export default FloatingViewPanel;
